import React from 'react';
import { Breadcrumb, BreadcrumbProps } from 'semantic-ui-react';

export type IBreadcrumbProps = BreadcrumbProps;

export const ATMBreadcrumb: React.FC<IBreadcrumbProps> = ({ ...props }) => (
  <Breadcrumb {...props} />
);
